import React from 'react'
import { useSelector } from 'react-redux'
import validationConfig from './validationConfig'
import CustomCollapse from '../../CustomCollapse'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../helpers/FormValidators'
import { ImagePickerField, SelectField, TextArea, TextField, ToggleCheckbox } from '../../FormFields'

const BasicSettingsForm = ({ formState, disabled, isInternalApp, isCreateNewMode }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const allApplicationCategories = useSelector(({ lookupData }) => lookupData?.allApplicationCategories)

  const accountingBureauApplicationCategoryId = allApplicationCategories?.find(x => x.displayName === "Regnskapsbyrå")?.value ?? -1;

  //  ===== Methods =====
  const onChange = (key, value) => {
    onFormDataChanged(key, value)

    if (key === "applicationCategoryId") {
      const validationConfigAgency = validationConfig?.find(x => x.key === "agencyCompanyKey");
      if (validationConfigAgency?.rules) {
        if (value === accountingBureauApplicationCategoryId) {
          validationConfigAgency.rules.isRequired = true;
        } else {
          validationConfigAgency.rules.isRequired = false;
        }
      }
    }

    validateFormField(key, value, validationConfig)
  }

  return (
    <CustomCollapse
      title="Basic information"
      description="These are the basic settings of your application"
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <TextField
        displayName="App Name"
        onChange={(value) => onChange("name", value)}
        errorMessage={formErrors["name"]?.message}
        value={formData["name"]}
        disabled={disabled}
      />
      <TextArea
        displayName="App Description"
        onChange={(value) => onChange("description", value)}
        errorMessage={formErrors["description"]?.message}
        value={formData["description"]}
        disabled={disabled}
      />
      <SelectField
        displayName="Application Category"
        placeholder="Select application category"
        onChange={(value) => onChange("applicationCategoryId", value)}
        errorMessage={formErrors["applicationCategoryId"]?.message}
        options={Array.isArray(allApplicationCategories) ? allApplicationCategories : []}
        value={formData["applicationCategoryId"]}
        disabled={disabled}
      />
      {(!isInternalApp && !isCreateNewMode) && (
        <>
          <ToggleCheckbox
            displayName="Is Single Tenant"
            onChange={(value) => onChange("isSingleTenant", value)}
            value={formData["isSingleTenant"]}
            disabled={disabled}
          />
          <ImagePickerField
            displayName="App Icon"
            onChange={(value) => onChange("image", value)}
            errorMessage={formErrors["image"]?.message}
            value={formData["image"]}
            disabled={disabled}
          />
        </>
      )}


      {formData["applicationCategoryId"] === accountingBureauApplicationCategoryId && (
        <TextField
          displayName="Bureau Company Key"
          placeholder="Enter the Bureau Company Key"
          onChange={(value) => onChange("agencyCompanyKey", value)}
          errorMessage={formErrors["agencyCompanyKey"]?.message}
          value={formData["agencyCompanyKey"]}
          disabled={disabled}
        />
      )}
    </CustomCollapse>
  )
}

export default BasicSettingsForm
